import config from './config';
import store from '../store/index';

const axios = require('axios').default;

export default class Auth {
    loginreturn = {
        status: 'OK',
    };

    isloggued = false;

    async login(username, _password) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}login`, { email: username, password: _password }).then((response) => {
            self.loginreturn.status = response.data.status;
            self.loginreturn.bearer = response.data.token;
            window.localStorage.setItem('bearer', self.loginreturn.bearer);
            store.state.bearer = self.loginreturn.bearer;
            store.state.userisloggued = true;
            store.state.username = response.data.username;
            store.state.isadmin = response.data.isadmin;
            store.state.mustcompleteprofile = response.data.mustcompleteprofile;
            store.state.showExam = response.data.showExam;
            store.state.exampassed = response.data.exampassed;
            return self.loginreturn;
        }).catch((response) => {
            self.loginreturn.status = 'ERROR';
            self.loginreturn.msg = response.response.data.msg;
            return self.loginreturn;
        });
    }

    logout() {
        this.isloggued = false;
        store.state.userisloggued = false;
        store.state.bearer = '';
        window.localStorage.removeItem('bearer');
        return true;
    }

    async isLoggued() {
        if (store.state.userisloggued) {
            this.isloggued = true;
            return this.isloggued;
        }

        const thebearer = window.localStorage.getItem('bearer');
        if (thebearer) {
            const self = this;
            const domain = config.basedomain;
            return axios.post(`${domain}login/checkbearer`, { bearer: thebearer }).then((response) => {
                if (response.data.status === 'OK') {
                    store.state.userisloggued = true;
                    self.isloggued = true;
                    store.state.bearer = thebearer;
                    store.state.username = response.data.username;
                    store.state.isadmin = response.data.isadmin;
                    store.state.mustcompleteprofile = response.data.mustcompleteprofile;
                    store.state.showExam = response.data.showExam;
                    store.state.exampassed = response.data.exampassed;
                    return self.isloggued;
                }
                self.isloggued = false;
                store.state.userisloggued = false;
                store.state.bearer = '';
                return self.isloggued;
            }).catch(() => {
                self.isloggued = false;
                store.state.userisloggued = false;
                return self.isloggued;
            });
        }

        return this.isloggued;
    }
}
